<template>
    <div class="af-jobview-widget">
        <div
            v-if="!$_job.is_expired"
            class="af-jobview-actions afu-grid afu-mb-5"
        >
            <ApplyJob
                :job-uuid="$_job.uuid"
                :is-offsite-apply="$_job.is_offsite_apply"
                :is-complete-apply="$_job.is_complete_apply"
                :job-applied-at="$_job.applied_at"
                :user-application-count="$_job.user_application_count"
            />
        </div>
        <div
            v-else
            class="af-jobview-actions afu-grid afu-mb-5"
        >
            <C1Button
                type="button"
                variant="outline-secondary"
                disabled
                size="lg"
                class="afu-font-bold"
            >
                <template>
                    {{ $t('job_view.expired') }}
                </template>
            </C1Button>
            <span class="afu-pt-5 afu-text-danger">{{ $t('job_view.expired_desc') }}</span>
        </div>
        <div class="af-jobview-actions afu-pt-5 afu-pb-8 afu-px-4 afu-shadow-card afu-rounded-card afu-bg-white">
            <JobViewActions />
            <JobViewShare v-if="!$_job.is_expired" />
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import JobViewActions from './JobViewActions';
    import JobViewShare from './JobViewShare';
    import ApplyJob from './Actions/ApplyJob';
    import C1Button from '@/components/C1Components/C1Button';

    export default {
        name: 'JobViewWidget',

        components: {
            JobViewActions,
            JobViewShare,
            ApplyJob,
            C1Button,
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),
        },
    };
</script>
